@if (edge) {
  <div class="absolute top-0 right-0 h-full w-96 bg-white dark:bg-gray-900 shadow-2xl z-20 flex flex-col transform transition-transform duration-300 ease-in-out">
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-800">
      <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
        Relationship Details
      </h3>
      <div>
        <button
          (click)="close.emit()"
          data-testid="close-sidebar-button"
          class="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 ml-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 p-4 overflow-y-auto">
      <!-- Properties Section -->
      @if (hasProperties) {
        <div class="space-y-2 text-sm">
          @for (prop of properties; track prop.key) {
            <div class="bg-gray-100 dark:bg-gray-800 p-2 rounded-md break-words">
              <p class="font-mono text-xs text-gray-500 dark:text-gray-400">{{ prop.key }}</p>
              <p class="font-semibold text-gray-900 dark:text-gray-100 whitespace-pre-line">{{ prop.value }}</p>
            </div>
          }
        </div>
      } @else {
        <p class="text-sm text-gray-500 dark:text-gray-400 italic">No properties found for this relationship.</p>
      }
    </div>
  </div>
}
